/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-pascal-case */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

// import NewContentList from "./NewContentList";

import Event202204_contentList from "./Event202204_contentList";
// import Event202204_cart from "./Event202204_cart";
import Event202204_pop from "./Event202204_pop";

//import '../../css/event210621.css'
//import '../../css/event211217.css'

import "../../css/event220316.css";

import { toast } from "react-toastify"; //토스트(toast)
import moment from "moment";
// import { isMobile } from "react-device-detect";

class Event202204_newContent extends Component {
  state = {
    eventCode: 0,
    grade: 1,
    kecode: "",
    show: false,
    reset: false,
    list: [],
  };
  componentDidMount = () => {
    this._getData();
  };
  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const orderList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        orderList,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      //toast.error('주문내역이 존재하지 않습니다.')
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202204_list", {
      params: {},
    });
  };

  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    let os = "";

    const mobile = /iphone|ipad|ipod|android/i.test(
      navigator.userAgent.toLowerCase()
    );

    if (mobile) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search("android") > -1) {
        os = "android";
      } else if (
        userAgent.search("iphone") > -1 ||
        userAgent.search("ipod") > -1 ||
        userAgent.search("ipad") > -1
      ) {
        os = "ios";
      } else {
        os = "otehr";
      }
    } else {
      os = "pc";
    }

    if (today <= "2021-12-28 00:00:00") {
      toast.warn("12월 28일 이후 확인이 가능합니다.");
    } else {
      //alert(0)
      //setEventIdx(0)
      if (os === "pc") {
        setTimelineWeek(true);
      } else {
        if (os === "ios") {
          setTimeout(function () {
            window.open("https://apps.apple.com/kr/app/id687631772", "", "");
          }, 1500);

          window.location.href = "aniplustv://TimeTable";
        } else {
          //setTimeout(function () {
          //window.open(android_appstore_url);
          //}, 1500);

          window.location.href = "aniplustv://TimeTable";
        }

        //this.action_app('aniplustv://TimeTable', 'aniplustv://TimeTable', 'https://itunes.apple.com/kr/app/instagram/id687631772', 'https://play.google.com/store/apps/details?id=com.aniplustv.android')
      }
    }
  };
  _goGoogle = () => {
    window.open("https://forms.gle/FSSs1qRRo9vmhpJdA", "", "");
  };
  _setGrade = (grade) => {
    this.setState({
      grade,
    });

    if (grade === 4) {
      //주문
      //this._licens()
    }
  };
  _makeKeycode = () => {
    const keycode = Math.random().toString(36).substr(2, 11);

    this.setState({
      keycode: keycode,
    });
  };

  _licens = async () => {
    const result = await this._licensApi();
    const intReturn = result.data[0].intReturn;
    const list = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        list,
        show: true,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("확인이 가능합니다.");
    }
  };
  _expect = async (contentSerial, img, title, alramFlag, grade) => {
    const { list, keycode } = this.state;

    let code = "";
    //console.log(keycode)
    if (keycode === "" || keycode === null || keycode === undefined) {
      this._makeKeycode();
    } else {
      code = keycode;
    }

    //if(list.length >= 3) {
    //toast.warn('3개까지만 주문이 가능합니다.')

    //} else {
    const result = list.find((item, index) => {
      return item.contentSerial === contentSerial;
    });

    if (result === undefined || result === null || result === "") {
      if (list.length >= 6) {
        toast.warn("6개 작품의 타깃이 지정 가능합니다.");
        return 0;
      } else {
        list.push({
          contentSerial: contentSerial,
          img: img,
          title: title,
          alramFlag: 100,
        });

        if (list.length === 6) {
          this._order();
        }

        setTimeout(() => {
          this.setState({
            list: list,
            reset: list.length === 6 ? true : false,
            show: list.length === 6 ? true : false,
          });
        }, 700);

        return 100;
      }
    } else {
      //toast.warn('이미 같은 콘텐츠가 존재합니다.')
      const result = list.findIndex((item, index) => {
        return item.contentSerial === contentSerial;
      });

      //console.log(result)
      //console.log(list)

      list.splice(result, 1);

      this.setState({
        list: list,
        reset: false,
      });
      return 0;
    }
    //}
  };
  _reset = () => {
    this.setState({
      list: [],
      reset: true,
    });
  };
  _order = async () => {
    const { list, keycode } = this.state;
    let contentSerial = "";
    if (list.length <= 0) {
      toast.warn("작품을 선택해주세요.");
    } else {
      list.map((item, index) => {
        contentSerial = contentSerial + item.contentSerial + "|";
      });

      //console.log(contentSerial, keycode)

      const result = await this._orderApi(contentSerial, keycode);
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        //레이어 팝업 띄울것...팝업에서 ip adress로 최신거 목록 불러올것.!!!!!
        this.setState({
          show: true,
        });
      }
    }
  };
  _orderApi = (contentSerial, keycode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202204_order", {
        params: {
          contentSerial: contentSerial,
          keycode: keycode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _close = () => {
    this.setState({
      show: false,
    });
  };
  _show = () => {
    const { list } = this.state;

    if (list.length === 6) {
      this.setState({
        show: true,
      });
    } else if (list.length < 6) {
      toast.warn("6개의 타깃을 설정해 주세요");
      //alert('6개의 타깃을 설정해 주세요')
    }
  };
  _go = () => {
    window.open("https://forms.gle/FSSs1qRRo9vmhpJdA", "", "");
  };
  render() {
    const { grade, keycode, show, list, reset, orderList } = this.state;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");
    return (
      <Fragment>
        <div className="event_head">
          {/*<button type="button" onclick="history.back()"><img src="//img/event/back.png" alt="뒤로"/></button>*/}
          <h3>애니플러스 신작 이벤트</h3>
          <button type="button" className="btnClose">
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220316">
            {show ? <Event202204_pop close={this._close} /> : null}

            <div className="sticky">
              <div className="quick">
                <a href="#top">
                  <img src="/img/event/event220316/quick01.png" alt="응모" />
                </a>
                <a href="#newList">
                  <img
                    src="/img/event/event220316/quick02.png"
                    alt="신작목록"
                  />
                </a>
                <a href="#gift">
                  <img src="/img/event/event220316/quick03.png" alt="경품" />
                </a>
                <a onClick={this._timeTable} style={{ cursor: "pointer" }}>
                  <img
                    src="/img/event/event220316/quick04.png"
                    alt="요일별시간표"
                  />
                </a>
                <a href="#comment">
                  <img src="/img/event/event220316/quick05.png" alt="댓글" />
                </a>
              </div>
            </div>
            {/*
                        <div className="btm_bar">
                            <div className="bar">
                                <ul>
                                   
                                    <Event202204_cart 
                                        list={list}
                                    />
                                    <li>
                                        <button type="button" className={list.length > 0 ? "btn btn01_active" : "btn btn01"} onClick={this._order}>신작 주문하기</button>
                                        <button type="button" className={list.length > 0 ? "btn btn02_active" : "btn btn02"} onClick={this._reset}>새로고침</button>
                                    </li>
                                   
                                    <li>
                                        <img src="/img/event/event220316/bar_next.png" alt="next"/>
                                    </li>
                                    <li>
                                        <button type="button" className={orderList ? "btn btn03_active" : "btn btn03"} onClick={this._show}>신작카페 주문 내역서 확인하기</button>
                                        <button type="button" className="btn btn04_active" onClick={this._go}>주문 내역서 인증샷 응모하기</button>
                                    </li>
                                </ul>
                                <img src="/img/event/event220316/bar.png" className="img_web"/>
                                <img src="/img/event/event220316/m_bar.png" className="img_m"/>
                            </div>
                        </div>
                        */}
            <div className="main">
              <a name="top"></a>
              <div className="bullet">
                <img src="/img/event/event220316/top_img.png" />
              </div>
              <img
                src="/img/event/event220316/backimg_1.png"
                alt="애니플러스 시크릿 에이전트"
                className="img_web"
              />
              <img
                src="/img/event/event220316/m_backimg_1.png"
                alt="애니플러스 시크릿 에이전트"
                className="img_m"
              />
              <h2>
                <img
                  src="/img/event/event220316/list_top.png"
                  alt="애니플러스 2분기 신작 수배서"
                  className="img_web"
                />
                <img
                  src="/img/event/event220316/m_list_top.png"
                  alt="애니플러스 2분기 신작 수배서"
                  className="img_m"
                />
              </h2>
            </div>

            <a name="newList"></a>

            <Event202204_contentList
              eventCode={1}
              keycode={keycode}
              _setGrade={this._setGrade}
              _makeKeycode={this._makeKeycode}
              _expect={this._expect}
              reset={reset}
            />

            <Event202204_contentList
              eventCode={2}
              keycode={keycode}
              _setGrade={this._setGrade}
              _makeKeycode={this._makeKeycode}
              _expect={this._expect}
              reset={reset}
            />

            <Event202204_contentList
              eventCode={3}
              keycode={keycode}
              _setGrade={this._setGrade}
              _makeKeycode={this._makeKeycode}
              _expect={this._expect}
              reset={reset}
            />
            <Event202204_contentList
              eventCode={4}
              keycode={keycode}
              _setGrade={this._setGrade}
              _makeKeycode={this._makeKeycode}
              _expect={this._expect}
              reset={reset}
            />
            <Event202204_contentList
              eventCode={5}
              keycode={keycode}
              _setGrade={this._setGrade}
              _makeKeycode={this._makeKeycode}
              _expect={this._expect}
              reset={reset}
            />

            <Event202204_contentList
              eventCode={6}
              keycode={keycode}
              _setGrade={this._setGrade}
              _makeKeycode={this._makeKeycode}
              _expect={this._expect}
              reset={reset}
            />

            {/*
                                <Event202201_cart 
                                    list={list}
                                />
                                <div onClick={this._order}>주문하기</div>
                                <div onClick={this._reset}>다시선택하기</div>
                                <div onClick={this._show}>내역확인</div>
                                */}
            <div className="btm">
              <a name="gift"></a>
              <a
                onClick={this._timeTable}
                className="link"
                style={{ cursor: "pointer" }}
              >
                신작 요일별 시간표 보기
              </a>
              <img
                src="/img/event/event220316/backimg_8.png"
                alt="리워드 상품 안내"
                className="img_web"
              />
              <img
                src="/img/event/event220316/m_backimg_8.png"
                alt="리워드 상품 안내"
                className="img_m"
              />
            </div>
            <div className="btm btn">
              <a
                onClick={this._show}
                className="link"
                style={{ cursor: "pointer" }}
              >
                리워드 내역 확인하기
              </a>
              <a
                onClick={this._go}
                className="link"
                style={{ cursor: "pointer" }}
              >
                리워드 내역 구글 폼 응모하기
              </a>
              <img
                src="/img/event/event220316/backimg_9.png"
                alt="하단 버튼"
                className="img_web"
              />
              <img
                src="/img/event/event220316/m_backimg_9.png"
                alt="하단 버튼"
                className="img_m"
              />
            </div>
          </div>
        </div>
        <a name="comment"></a>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202204_newContent));
